<section class="content">
    <div class="container-fluid">
        <div class="col-md-12 col-sm-12">
            <h6 class="modal-title pull-left"> <span class="back" (click)="back()"> <i class="fas fa-arrow-left">
                    </i>&nbsp;
                    Back</span></h6>
        </div>
        <div class="box">
            <div class="box-header row">
                <div class="col-md-9 col-sm-12">
                    <h3 class="box-title">All Approved / Declined Users</h3>
                </div>
                <div class="col-md-4  col-sm-12">
                    <div class="input-group mb-3">
                        <input class="form-control search-btn" type="text" placeholder="Search" aria-label="Search"
                            aria-describedby="search-btn" [(ngModel)]="searchInput">
                        <div class="input-group-append">
                            <span class="input-group-text" id="search-btn">
                                <i class="fa fa-search text-grey" aria-hidden="true"></i>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <!-- /.box-header -->
            <div class="box-body table-responsive">
                <table id="example1" class="table table-bordered table-striped">
                    <thead>
                        <tr>
                            <th>Sl.No</th>
                            <th>User Name</th>
                            <th>Gate Name</th>
                            <th>Log Date Time</th>
                            <th>Approve Status</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            *ngFor="let item of userList  | filter:searchInput | paginate: { itemsPerPage: limit, currentPage: page, totalItems: count } let i = index">
                            <td>{{ limit*(page-1)+(i+1) }}.</td>
                            <td>{{ item.user_name}}</td>
                            <td>{{ item.gate_name}}</td>
                            <td>{{ item.created_at | date :"yyyy/MM/dd"}} at {{(item.created_at | date :"HH:mm") }}{{(item.created_at | date :"HH")>11?' PM':' AM' }}</td>
                            <td><span [ngClass]="item.approved_status==1?'approved btn-success':'rejected'"
                                    class="open">{{ item.approved_status==1?'Approved':"Declined"}}</span></td>
                            <td>
                                <button type="button" class="btn btn-sm btn-default mr-2 command-edit"
                                    (click)="openModal(item.user_id)">
                                    <em class="fa fa-eye fa-fw"></em>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div class="paginate">
                    <pagination-controls class="my-pagination"
                        (pageChange)="paginate(page = $event)"></pagination-controls>
                </div>
            </div>
            <!-- /.box-body -->
        </div>
        <!-- /.box -->
    </div>
</section>